import { SvgIconProps } from './icon-props';

export default function CloseCircle({
	height = 24,
	width = 24,
	className,
	fill = 'evenodd',
}: SvgIconProps) {
	return (
		<svg
			viewBox="0 0 24 24"
			width={width}
			height={height}
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<path
				d="m18.85 6.48-1.33-1.33L12 10.67 6.48 5.15 5.15 6.48 10.67 12l-5.52 5.52 1.33 1.33L12 13.33l5.52 5.52 1.33-1.33L13.33 12l5.52-5.52zM0 12.07C0 5.44 5.44 0 12.07 0s12 5.44 12 12.07-5.37 12-12 12S0 18.7 0 12.07z"
				fill={fill}
			/>
		</svg>
	);
}
